import './App.css';
import Footer from './components/footer/Footer2';
import HeroPromo from './components/hero/HeroPromo';
import HeroSlider from './components/hero/HeroSlider';
import InfoSection from './components/info/InfoSection';
import MostSearchedCategories from './components/most-searched/MostSearched';
import Navbar from './components/navbar/Navbar';
import ProductInfo from './components/product-info/ProductInfo';
import { products } from './components/products/data';
import ProductSlider from './components/products/ProductSlider';
import TopSeller from './components/top-sellers/TopSeller';
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom'; // Import BrowserRouter, Routes, and Route
import ProductDetails from './pages/ProductDetails';
import ShopPage from './pages/ShopPage';
import ProductTabs from './components/tabulator/ProductTabs';

function App() {
  return (
    <>
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroPromo />
              <HeroSlider />
              {/* <section>
                <h2 className="mb-5 text-[28px] font-bold text-black">Featured Products</h2>
                <ProductList products={products} />
              </section>
              <ProductSlider products={products}/> */}
              <MostSearchedCategories />
              <TopSeller />
              <ProductTabs />
              <InfoSection />
            </>
          }
        />
        <Route path="/computers/zeus-max" element={<ProductDetails />} />
        <Route path="/shop" element={<ShopPage />} />
      </Routes>
    </BrowserRouter>
    <Footer />
    </>
  );
}

export default App;
